import EditDialog from "@/components/common/EditDialog";
import type { EducationT, ExtendedEventViewT } from "@/types/database/events";
import EducationForm from "./EducationForm";
import EducationSummary from "./EducationSummary";

interface Props {
    diaryId: string;
    trackerId?: string;
    eventId: string;
    organisationId: string;
    education: EducationT;
    event: ExtendedEventViewT;
    editable: boolean;
}

const EducationItem = (props: Props) => {
    const { education, editable, diaryId, eventId, organisationId, event } =
        props;

    return (
        <>
            <EditDialog
                label="Education"
                info={<EducationSummary education={education} />}
                editable={editable}
            >
                <EducationForm
                    education={education}
                    educationId={education.education_id}
                    diaryId={diaryId}
                    eventId={eventId}
                    organisationId={organisationId}
                    event={event}
                />
            </EditDialog>
        </>
    );
};

export default EducationItem;
